<template>
    <div class="main-bg">
        <banner  :bgImage="bannerInfo.file || bgImage" class="news-banner" :title="bannerInfo.title" :subTitle="bannerInfo.desc">
        </banner>
        <div class="wrap">
            <div class="list" v-if="list.length>0">
                 <!-- 遍历图片数据（示例数据，实际可从接口获取） -->
                 <newsItem :item="item" source="news" v-for="(item,index) in list" :key="item.id"></newsItem>
            </div>
              <error :status="status" v-if="status>0"></error>
            <el-pagination class="pagination" background layout="prev, pager, next" :pager-count="5" 
                v-model:current-page="queryParams.pageNo"
                :page-size="queryParams.pageSize"
                :total="total"
                @current-change="getPage" v-show="total > 6" />
        </div>
    </div>
</template>

<script setup lang="ts">
// 1. 补全所有必要导入
import { ref,reactive} from 'vue'
import useServerRequest from '@/composables/useServerRequest'
import type { NewsListParams, GetNewsListResponse,configParams,configResponse,bannerConfig} from '~/types';
import { useI18n } from 'vue-i18n' // 导入 useI18n
const { locale,t } = useI18n() // 获取当前 i18n 语言（如 zh-CN/en-US）
const bgImage = ref<string>(staticURL('/banner/news-banner.webp'))
import { handleApiResponse } from "@/utils/utils"
const config = useRuntimeConfig()
const cmsurlStrategy = config?.public?.cmsStrategy
const total = ref<GetNewsListResponse['total']>(0);
const list = ref<GetNewsListResponse['list']>([])
// 定义查询参数（类型为 NewsListParams）
const queryParams = reactive<NewsListParams>({
  pageNo: 1,
  pageSize: 6, 
  searchKey: null,
});

//列表数据
const status=ref<number>(0) //0默认有数据 1接口有返回无数据 2其他获取接口失败
const getList = async () => {
    try {
          const { data } = await useServerRequest<GetNewsListResponse>('news-list', `${cmsurlStrategy}/getNewInformationPage`, { method: 'GET', params:queryParams,language: locale.value })
          // 1. 先判断 data 是否存在（防止接口返回空）
         if (!data?.value || !data.value.data?.list || data.value.data.list.length === 0) {
            status.value = 1;
            return;
         }
        const res = data.value;
        const result = handleApiResponse(res)
        if (!result.success) {
            status.value = result.status
            return
        }
        const getnewsData = data?.value?.data
        list.value=getnewsData.list
        total.value=getnewsData.total

    } catch(error) {
        status.value = 2
    }
}
getList()
//分页
const getPage = (val:number) => {
  queryParams.pageNo = val
  getList()
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}
const infoParams = reactive<configParams>({
    pageCode:"NEWS_INFO"
})
//其他信息
const seo = ref<configResponse['pageValue']['seo']>({
    title: '',
    keywords: '',
    desc: ''
})
const bannerInfo = ref<bannerConfig>({})
const getInfo = async () =>{
    try {
          const { data } = await useServerRequest<configResponse>('news-list-info', `${cmsurlStrategy}/getPageConfig`, { method: 'GET', params:infoParams,language: locale.value })
          const getInfoData = data?.value?.data?.pageValue
          seo.value=getInfoData?.seo
          bannerInfo.value = getInfoData?.banner?.[0] || {}; // 链式判断 + 默认值
    } catch(error){

    }
}
getInfo()
useHead({
    title: () => seo?.value?.title || '', // 保持不变（已正确）
    meta: [
        { 
        name: 'keywords', 
        content: () => seo?.value?.keywords || '' // 改为函数形式！
        },
        { 
        name: 'description', 
        content: () => seo?.value?.desc || '' // 改为函数形式！（去掉多余的模板字符串）
        }
    ]
})
</script>

<style lang="scss" scoped>
    @use '@/assets/css/news.scss';
</style>
